import { Input } from "@/components/forms/Input";
import { Label } from "@/components/forms/Label";

type TScoreRangeFilterProps = {
  label: string;
  min: string;
  max: string;
  onMinChange: (value: string) => void;
  onMaxChange: (value: string) => void;
  id: string;
};

const normalizeScore = (value: string) => value.replace(/[^0-9.]/g, "");

const ScoreRangeFilter = ({
  label,
  min,
  max,
  onMinChange,
  onMaxChange,
  id,
}: TScoreRangeFilterProps) => (
  <div className="w-full">
    <Label weight="medium">{label}</Label>
    <div className="flex items-center gap-2">
      <Input
        id={`${id}-min`}
        type="number"
        min="0"
        max="100"
        step="0.01"
        value={min}
        onChange={(event) => onMinChange(normalizeScore(event.target.value))}
        placeholder="Min"
        className="min-w-0"
      />
      <span className="text-muted-foreground">−</span>
      <Input
        id={`${id}-max`}
        type="number"
        min="0"
        max="100"
        step="0.01"
        value={max}
        onChange={(event) => onMaxChange(normalizeScore(event.target.value))}
        placeholder="Max"
        className="min-w-0"
      />
    </div>
  </div>
);

export default ScoreRangeFilter;
